import Instruction from "./Instruction";

/**
 * Call an other function, only difference with more traditional language is the absence of return value.
 * At the end of the called function, the flow will continue with the instruction just after this one.
 *
 * functionName can be resolve at runtime.
 */
class Call extends Instruction
{
	constructor(functionName)
	{
		super();
		this.functionName = functionName;
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.functionName = Instruction._resolveValue(this.functionName, variables);
	}
}

export default Call
